import { css } from 'styled-components';

export const regularFont = css`
  font-weight: 400;
`;

export const mediumFont = css`
  font-weight: 500;
`;

export const boldFont = css`
  font-weight: 700;
`;
